import React from 'react';
import {
  Box,
  Heading,
  List,
  ListItem,
  Stack,
  Strong,
  Text,
  TextLink,
} from '@origin-digital/ods-core';

export const BYOBattery = (
  <Stack space="xlarge">
    <Stack space={['medium', 'large']}>
      <img
        src="https://www.originenergy.com.au/cdn/images/originenergy/image/upload/v1727226810/icons/ic_custom_your-home-energy_yellow.svg"
        alt="BYO Battery"
        height="64px"
      />
      <Stack space="large">
        <Heading variant="h3">Connect your battery to Origin Loop to unlock more value</Heading>
        <Text>
          ​Looking to get more from your battery? Register your interest for Origin Loop and if you
          are eligible you’ll get a great sign-up bonus and <Strong>$1/kWh</Strong> for energy
          exported from your battery and sent to the grid during Origin Loop events.
        </Text>
      </Stack>

      <List>
        <Text>All you need is:</Text>
        <ListItem>
          A compatible inverter and solar battery of at least 5Wh usable capacity installed at your
          home.
        </ListItem>
        <ListItem>
          An operational solar system of at least 5kW capacity, compatible with your solar battery.
        </ListItem>
        <ListItem>Continuous and reliable internet connection to your inverter.</ListItem>
      </List>
    </Stack>
    <Box paddingY="large" paddingX="medium" backgroundColor="grey50" borderRadius="medium">
      <Stack space="medium">
        <List>
          <Heading variant="h4">Important things to know</Heading>
          <ListItem>Sign-up bonus applied as a credit to your Origin electricity bill.</ListItem>
          <ListItem>
            Get paid $1/kWh during Loop eventsFor energy exported and sent to the grid. Plus, still
            receive a competitive solar feed-in-tariff (FIT) applied as credits to your Origin
            electricity bill.
          </ListItem>
          <ListItem>
            200kWh annual cap on energy exports.​We’ll never take more than 200kWh from your battery
            annually as part of Origin Loop.
          </ListItem>
          <ListItem>
            No lock-in contracts​While we think you’ll love Origin Loop, with no lock-in contracts
            you can leave at any time. Eligibility, Terms and Conditions apply.
          </ListItem>
          <ListItem>Keep track of it all in the Origin app</ListItem>
        </List>
      </Stack>
    </Box>
    <Text>
      <TextLink
        href="https://www.originenergy.com.au/solar/panels-batteries/virtual-power-plant/byo/"
        target="_blank"
      >
        {'>'} Find out more about Origin Loop BYO Battery
      </TextLink>
    </Text>
    <Text>
      <TextLink
        href="https://www.originenergy.com.au/wp-content/uploads/103/Origin-Loop-VPP-Terms-and-Conditions-BYO-December-2023-v3.pdf"
        target="_blank"
      >
        {' '}
        {'>'} Terms and conditions
      </TextLink>
    </Text>
  </Stack>
);
